import { lazy } from 'react';

const RegionPage = lazy(() => import('./Regions/pages/RegionPage'));
const RegionDashboardPage = lazy(() => import('./RegionDashboard/RegionDashboard'));
const RegionDashboardOverviewPage = lazy(
  () => import('./RegionDashboard/pages/RegionDashboardOverview'),
);
const RegionDashboardLooksPage = lazy(() => import('./RegionDashboard/pages/RegionDashboardLooks'));
const RegionDashboardProductsPage = lazy(
  () => import('./RegionDashboard/pages/RegionDashboardProducts'),
);
const RegionDashboardOrdersPage = lazy(
  () => import('./RegionDashboard/pages/RegionDashboardOrders'),
);
const RegionInfoPage = lazy(() => import('./Regions/pages/RegionInfoPage'));
const RegionIntegrationsPage = lazy(() => import('./Regions/pages/RegionIntegrationsPage'));
const RegionCheckoutPage = lazy(() => import('./Regions/pages/RegionCheckoutPage'));
const RegionPageModulesPage = lazy(() => import('./Regions/pages/RegionPageModulesPage'));
const RegionSubscriptionsPage = lazy(() => import('./Regions/pages/RegionSubscriptionsPage'));
const RetailersPage = lazy(() => import('./Retailers/RetailersPage'));
const CustomStoresPage = lazy(() => import('./Stores/CustomStore'));
const ParentProductsPage = lazy(() => import('./Products/parentProductsPage'));
const ChildProductsPage = lazy(() => import('./Products/childProductsPage'));
const ColorsPage = lazy(() => import('./Colors/colorsPage'));
const SizesPage = lazy(() => import('./Sizes/sizesPage'));
const CategoriesPage = lazy(() => import('./Categories/categoriesPage'));
const InventoriesPage = lazy(() => import('./Inventories/inventoriesPage'));
const RetailerPage = lazy(() => import('./Retailer/RetailerPage'));
const RetailerDetailsPage = lazy(() => import('./Retailer/RetailerDetailsPage'));
const RetailerDetailsLooksPage = lazy(() => import('./Retailer/RetailerDetailsLooksPage'));
const RetailerDetailsProductsPage = lazy(() => import('./Retailer/RetailerDetailsProductsPage'));
const RetailerLooksPage = lazy(() => import('./Looks/pages/RetailerLooksPage'));
const AdminLooksPage = lazy(() => import('./Looks/pages/AdminLooksPage'));
const AdminEditLookPage = lazy(() => import('./Looks/pages/EditLookPage/AdminEditLookPage'));
const EditLookPage = lazy(() => import('./Looks/pages/EditLookPage/EditLookPage'));
const FavouriteProductsPage = lazy(() => import('./FavouriteProducts'));
const ProductsPage = lazy(() => import('./Products'));
const BrandManagerPage = lazy(() => import('./BrandManager'));
const BrandInformationPage = lazy(() => import('./BrandManager/BrandInformationPage'));
const BrandManagerThemeCustomizationPage = lazy(
  () => import('./BrandManager/BrandManagerThemeCustomizationPage'),
);
const BannersPage = lazy(() => import('./Banners/BannersPage'));
const VideosPage = lazy(() => import('./Videos/VideosPage'));
const DefaultLookImagePage = lazy(() => import('./DefaultLookImage/DefaultLookImagePage'));
const HowToHubPage = lazy(() => import('./HowToHub/HowToHubPage'));
const HowToHubRetailerPage = lazy(() => import('./HowToHub/HowToHubRetailerPage'));
const EventsPage = lazy(() => import('./Events/EventsPage'));
const AdminEventsPage = lazy(() => import('./AdminEventsPage/AdminEventsPage'));
const LocationsPage = lazy(() => import('./Locations/LocationsPage'));
const RetailerLocationsPage = lazy(() => import('./Locations/RetailerLocationsPage'));
const LocationGroupsPage = lazy(() => import('./Locations/LocationGroupsPage'));
const LocationPage = lazy(() => import('./Location/LocationPage'));
const RetailerLocationPage = lazy(() => import('./Location/RetailerLocationPage'));
const OrdersPage = lazy(() => import('./Orders/OrdersPage'));
const RetailerSalesPage = lazy(() => import('./RetailerSales/RetailerSalesPage'));
const OrderPage = lazy(() => import('./Order/OrderPage'));
const SuperUserPage = lazy(() => import('./SuperUser/SuperUserPage'));
const SuperUserOrdersPage = lazy(() => import('./SuperUser/SuperUserOrdersPage'));
const SuperUserTiersPage = lazy(() => import('./SuperUser/SuperUserTiersPage'));
const SuperUserRegionsPage = lazy(() => import('./SuperUser/SuperUserRegionsPage'));
const SuperUserRegionDetailPage = lazy(() => import('./SuperUser/SuperUserRegionDetailPage'));
const SuperUserUsersPage = lazy(() => import('./SuperUser/SuperUserUsersPage'));
const SuperUserImpersonationPage = lazy(() => import('./SuperUser/SuperUserImpersonationPage'));
const WidgetShopifyGuidePage = lazy(() => import('./Widgets/WidgetShopifyGuidePage'));

export {
  AdminEditLookPage,
  AdminEventsPage,
  AdminLooksPage,
  BrandInformationPage,
  BrandManagerPage,
  BrandManagerThemeCustomizationPage,
  CategoriesPage,
  ChildProductsPage,
  ColorsPage,
  BannersPage,
  VideosPage,
  CustomStoresPage,
  DefaultLookImagePage,
  EditLookPage,
  EventsPage,
  FavouriteProductsPage,
  HowToHubPage,
  HowToHubRetailerPage,
  InventoriesPage,
  LocationGroupsPage,
  LocationPage,
  LocationsPage,
  OrderPage,
  OrdersPage,
  RetailerSalesPage,
  ParentProductsPage,
  ProductsPage,
  RegionDashboardPage,
  RegionDashboardLooksPage,
  RegionDashboardProductsPage,
  RegionDashboardOrdersPage,
  RegionDashboardOverviewPage,
  RegionCheckoutPage,
  RegionInfoPage,
  RegionIntegrationsPage,
  RegionPageModulesPage,
  RegionPage,
  RegionSubscriptionsPage,
  RetailerPage,
  RetailerDetailsPage,
  RetailerDetailsLooksPage,
  RetailerDetailsProductsPage,
  RetailerLocationPage,
  RetailerLocationsPage,
  RetailerLooksPage,
  RetailersPage,
  SizesPage,
  SuperUserPage,
  SuperUserOrdersPage,
  SuperUserRegionDetailPage,
  SuperUserRegionsPage,
  SuperUserTiersPage,
  SuperUserUsersPage,
  SuperUserImpersonationPage,
  WidgetShopifyGuidePage,
};
